// Migrated 1:1 from @nexato/nx-core-module (components/billing-invoice-receiver-edit-email-dialog, #685)
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Tenant } from '../../entities/tenant/tenant';
import { GroupsService } from '../../services/groups/groups.service';
import { LoadingService } from '../../services/loading.service';
import { LocationService } from '../../services/location/location.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { UsersService } from '../../services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-billing-invoice-receiver-edit-email',
  templateUrl: './billing-invoice-receiver-edit-email.component.html',
  styleUrls: ['./billing-invoice-receiver-edit-email.component.scss']
})
export class BillingInvoiceReceiverEditEmailDialogComponent
  implements EditDialogInstance {

    invoiceEmailForm: FormGroup;
    tenant: Tenant;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public groupService: GroupsService,
    public loadingService: LoadingService,
    public locationService: LocationService,
    public tenantService: TenantsService
  ) {

    if (this.config.data) {
      this.tenant = this.config.data;
    }

    this.invoiceEmailForm = new FormGroup({});
    this.invoiceEmailForm.addControl('invoiceEmail', new FormControl(undefined, [Validators.required, Validators.email]));

    if(this.tenant){
      this.invoiceEmailForm.patchValue(this.tenant);
    }
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    this.tenantService?.updateInvoiceMail(this.tenant?.id, this.invoiceEmailForm.get('invoiceEmail').value, () => {
      this.loadingService.setLoading(false);
      this.ref.close(true);
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.invoiceEmailForm;
  }
}
